import { render, staticRenderFns } from "./zfb.vue?vue&type=template&id=2cea2282"
import script from "./zfb.vue?vue&type=script&lang=js"
export * from "./zfb.vue?vue&type=script&lang=js"
import style0 from "./zfb.vue?vue&type=style&index=0&id=2cea2282&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports